import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FaPhone, 
  FaExclamationTriangle,
  FaShieldAlt,
  FaCalendarAlt,
  FaCheckCircle
} from 'react-icons/fa';
import { LuBug } from "react-icons/lu";
import '../../assets/css/descupinizacaopage.css';
import SeoHead from "../../components/Menu/components/SeoHead";

const descupinizacaoImages = [
  { id: 1, src: '/img/cupim/1.jpg', alt: 'Exclusivo serviço de descupinização para pianos com resultados garantidos' },
  { id: 2, src: '/img/cupim/2.jpg', alt: 'Procedimento exclusivo de descupinização em câmara especializada' },
  { id: 3, src: '/img/cupim/3.jpg', alt: 'Piano completamente livre de cupins após o tratamento exclusivo' },
  { id: 4, src: '/img/cupim/4.jpg', alt: 'Serviço especializado de descupinização preservando a estrutura original do piano' },
  { id: 5, src: '/img/cupim/5.jpg', alt: 'Piano restaurado e protegido com método de descupinização exclusivo' },
];

const descupinizacaoSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Descupinização de Pianos",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg", 
    "url": "https://pianoswaldir.com.br",
    "telephone": "+55-11-2256-5987", 
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Waldemar Martins, 695",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "02535-000", 
      "addressCountry": "BR"
    }
  },
  "name": "Serviço Exclusivo de Descupinização de Pianos | Waldir Pianos",
  "description": "Serviço exclusivo e 100% eficaz de descupinização para pianos contra cupins e brocas. Utilizamos tratamento químico quarentenário em câmara especializada, preservando a estrutura do instrumento.",
  "image": "https://pianoswaldir.com.br/img/cupim/1.jpg", 
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Detalhes do Serviço de Descupinização",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Descupinização de Pianos com Tratamento Quarentenário"
        },
        "description": "Tratamento exclusivo em câmara, 100% eficaz contra cupins e brocas, sem danificar o piano."
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Proteção e Preservação de Pianos"
        },
        "description": "Processo que dura cerca de 15 dias, garantindo a eliminação total da infestação e proteção futura."
      }
    ]
  },
  "url": "https://pianoswaldir.com.br/descupinizacao-de-pianos",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://pianoswaldir.com.br/descupinizacao-de-pianos"
  }
};

const DescupinizacaoPianosExclusivo = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % descupinizacaoImages.length
        );
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = descupinizacaoImages[currentImageIndex];

  return (
    <div className="descupinizacao-exclusivo-container">
      <SeoHead
  title="Descupinização de Pianos | Método Exclusivo e 100% Eficaz | Waldir Pianos"
  description="Proteja seu piano contra cupins e brocas com o serviço de descupinização exclusivo da Waldir Pianos. Tratamento em câmara especializado e garantia de eliminação total da praga. Fale conosco!"
  keywords="descupinização de pianos, descupinizar piano, cupim no piano, broca no piano, tratamento cupim piano, Waldir Pianos descupinização, eliminar cupim piano, serviço especializado piano"
  image="/img/cupim/1.jpg" 
  url="https://pianoswaldir.com.br/descupinizacao-de-pianos"
  canonicalUrl="https://pianoswaldir.com.br/descupinizacao-de-pianos"
  schemaMarkup={descupinizacaoSchema}
/>
      {/* Cabeçalho */}
      <motion.header 
        className="descupinizacao-exclusivo-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="descupinizacao-exclusivo-header-content">
          <motion.h1 
            className="descupinizacao-exclusivo-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <LuBug className="descupinizacao-exclusivo-title-icon" />
            Serviço de Descupinização
            <span className="descupinizacao-exclusivo-title-decoration"></span>
          </motion.h1>
          
          <motion.p 
            className="descupinizacao-exclusivo-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Proteção especializada para seu piano
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="descupinizacao-exclusivo-main-content">
        {/* Seção de Texto */}
        <div className="descupinizacao-exclusivo-grid-2x2">
          {/* Linha 1 */}
          <motion.section 
            className="descupinizacao-exclusivo-grid-item"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
          >
            {/* Texto: A ameaça dos cupins + moderna */}
            <div className="descupinizacao-exclusivo-text-content">
              <h2 className="descupinizacao-exclusivo-section-title">
                <FaExclamationTriangle className="descupinizacao-exclusivo-section-icon" />
                A ameaça dos cupins
              </h2>
              <p className="descupinizacao-exclusivo-classic-text">
                "Uma infestação de cupins ou brocas é a principal ameaça a um piano. Um curto período de tempo a partir da identificação das pragas basta para que o instrumento seja totalmente consumido."
              </p>
              <div className="descupinizacao-exclusivo-modern-text">
                <p>Quando afetados componentes vitais do seu interior, o piano pode ficar inutilizado. Sem falar nos riscos de infestação nos outros móveis do ambiente.</p>
                <p>Existem diversas técnicas de descupinização no mercado, praticadas em sua maioria por dedetizadores. Porém são ineficazes em Pianos, pois danificam alguns dos milhares de componentes e não acessam seu interior eliminando o foco.</p>
              </div>
            </div>
          </motion.section>

          <motion.section 
            className="descupinizacao-exclusivo-grid-item"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Galeria */}
            <h3 className="descupinizacao-exclusivo-gallery-title">Nosso Processo</h3>
            <motion.div 
              className="descupinizacao-exclusivo-gallery-container"
              key={currentImageIndex}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
            >
              <div className="descupinizacao-exclusivo-piano-image">
                <img 
                  src={currentImage.src} 
                  alt={currentImage.alt}
                  className="descupinizacao-exclusivo-gallery-image"
                />
                <div className="descupinizacao-exclusivo-image-overlay">
                  <span className="descupinizacao-exclusivo-piano-description">{currentImage.alt}</span>
                </div>
              </div>
            </motion.div>
            <div className="descupinizacao-exclusivo-gallery-dots">
              {descupinizacaoImages.map((_, index) => (
                <button
                  key={index}
                  className={`descupinizacao-exclusivo-dot ${index === currentImageIndex ? 'descupinizacao-exclusivo-dot-active' : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          </motion.section>

          {/* Linha 2 */}
          <motion.section 
            className="descupinizacao-exclusivo-grid-item"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
          >
            {/* Nossa solução exclusiva */}
            <h2 className="descupinizacao-exclusivo-section-title descupinizacao-exclusivo-solution-title">
              <FaShieldAlt className="descupinizacao-exclusivo-section-icon" />
              Nossa solução exclusiva
            </h2>
            <div className="descupinizacao-exclusivo-solution-features">
              <div className="descupinizacao-exclusivo-feature-item">
                <FaCheckCircle className="descupinizacao-exclusivo-feature-icon" />
                <span>Dominamos a única técnica 100% eficaz e apropriada para Pianos</span>
              </div>
              <div className="descupinizacao-exclusivo-feature-item">
                <FaCheckCircle className="descupinizacao-exclusivo-feature-icon" />
                <span>Tratamento químico quarentenário em câmara apropriada</span>
              </div>
              <div className="descupinizacao-exclusivo-feature-item">
                <FaCalendarAlt className="descupinizacao-exclusivo-feature-icon" />
                <span>Processo dura cerca de 15 dias garantindo eliminação total</span>
              </div>
            </div>
          </motion.section>

          <motion.section 
            className="descupinizacao-exclusivo-grid-item"
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
          >
            {/* Imagem do selo */}
            <div className="descupinizacao-exclusivo-solution-image">
              <img 
                src="/img/selo.webp" 
                alt="Tratamento Exclusivo"
                className="descupinizacao-exclusivo-solution-img"
              />
            </div>
          </motion.section>
        </div>
      </div>

      {/* Rodapé */}
      <motion.footer 
        className="descupinizacao-exclusivo-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="descupinizacao-exclusivo-footer-text">Proteja seu piano contra cupins com o único método 100% eficaz</p>
        <motion.a
          href="tel:1122565987"
          className="descupinizacao-exclusivo-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default DescupinizacaoPianosExclusivo;